var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategoriasBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.736,
    height: 22,
    viewBox: "0 0 32.736 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_147ba8c6548c9a08500ec8755a2ac705",
    "data-name": "147ba8c6548c9a08500ec8755a2ac705",
    transform: "translate(-10 -170.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_558",
    "data-name": "Caminho 558",
    d: "M10,173.225a2.525,2.525,0,1,0,5.051,0h0a2.525,2.525,0,1,0-5.051,0Z",
    transform: "translate(0 0)",
    fill: "#009ebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_559",
    "data-name": "Caminho 559",
    d: "M272.484,175.751H252.825a2.534,2.534,0,0,1-2.525-2.525h0a2.534,2.534,0,0,1,2.525-2.525h19.658a2.534,2.534,0,0,1,2.525,2.525h0A2.534,2.534,0,0,1,272.484,175.751Z",
    transform: "translate(-232.273 0)",
    fill: "#009ebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_560",
    "data-name": "Caminho 560",
    d: "M10,426.925a2.525,2.525,0,1,0,2.525-2.525A2.526,2.526,0,0,0,10,426.925Z",
    transform: "translate(0 -245.225)",
    fill: "#009ebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_561",
    "data-name": "Caminho 561",
    d: "M272.484,429.451H252.825a2.534,2.534,0,0,1-2.525-2.525h0a2.534,2.534,0,0,1,2.525-2.525h19.658a2.534,2.534,0,0,1,2.525,2.525h0A2.534,2.534,0,0,1,272.484,429.451Z",
    transform: "translate(-232.273 -245.225)",
    fill: "#009ebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_562",
    "data-name": "Caminho 562",
    d: "M10,680.525a2.525,2.525,0,1,0,5.051,0h0a2.525,2.525,0,0,0-5.051,0Z",
    transform: "translate(0 -490.354)",
    fill: "#009ebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_563",
    "data-name": "Caminho 563",
    d: "M272.484,683.151H252.825a2.534,2.534,0,0,1-2.525-2.526h0a2.534,2.534,0,0,1,2.525-2.525h19.658a2.534,2.534,0,0,1,2.525,2.525h0A2.534,2.534,0,0,1,272.484,683.151Z",
    transform: "translate(-232.273 -490.451)",
    fill: "#009ebe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriasBlue);
export default __webpack_public_path__ + "static/media/categoriasBlue.7f9aaa1d281426ba0048781a9b24813f.svg";
export { ForwardRef as ReactComponent };